import { IsNotEmpty } from 'class-validator';
// import { EpimsBaseEntityDto } from './epim-base.dto';

export class LeaseExpirationDto {
id: string;
SiteId: string;
ModifiedById: string;
CreatedById: string;
dateUpdated: Date;
dateCreated: Date;
ExpirationDateTo: Date;
ExpirationDateFrom: Date;
ExpirationDatePeriod: Date;
Version: Number;
ParcelId: string;
LandTitleId: string;
SubscriberId: string;
SubscriptionUserId: string;
}
